import { useEffect, useState } from "react";

type Listener = (state: { isOpen: boolean; message: string }) => void;

let state: { isOpen: boolean; message: string } = {
  isOpen: false,
  message: "",
};

const listeners: Listener[] = [];

function notify() {
  listeners.forEach((listener) => listener(state));
}

export function showServerMaintenanceDialog(message: string) {
  state = { isOpen: true, message };
  notify();
}

export function closeServerMaintenanceDialog() {
  state = { isOpen: false, message: "" };
  notify();
}

export function useServerMaintenanceState() {
  const [localState, setLocalState] = useState(state);

  useEffect(() => {
    const listener: Listener = (newState) => setLocalState(newState);
    listeners.push(listener);
    return () => {
      const index = listeners.indexOf(listener);
      if (index > -1) listeners.splice(index, 1);
    };
  }, []);

  return localState;
}
